export const getTodayAnswers = async (axios, config) => {
	return await axios
		.get(`${config.API_SERVICE}/v3/spelling_bee`)
		.then((response) => {
			return response.status === 200 && response.data.status === 200
				? response.data
				: {};
		})
		.catch((err) => {
			console.error(
				"Could not connect to the spelling bee endpoint. ",
				err
			);
		});
};
